<template>
  <div class="recommend">
    <div class="recommend__dialog">
      <div class="recommend__content">
        <div class="recommend__header">
          <button type="button" class="recommend__header--close" @click="closeSelf">
            <span>×</span>
          </button>
          <h4 class="recommend__header__title">{{ data.name }}</h4>
        </div>
        <div class="recommend__body">
          <h6>回答问题，给您推荐适合的课程</h6>
          <h5 style="display: none;">三年级英语</h5>
          <div class="recommend__question">
            <ul>
              <li v-for="(item, index) in data.question_list" :key="index">
                <h1>
                  <span>问题{{ item.sort_index }}：</span>{{ item.name }}
                </h1>
                <div v-for="(item, index) in item.option_list" :key="index">
                  <input
                    type="radio"
                    :value="item.id"
                    :id="item.id"
                    :name="item.question_id"
                    @click="addCheckMark(item.question_id, item.id)"
                  />
                  <label :for="item.id">{{ item.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <div class="recommend__footer">
            <h3 class="recommend__footer__tip01" v-if="answerAll">
              *请回答以上问题完成快速定级
            </h3>
            <div class="recommend__footer__btn">
              <button
                class="recommend__footer__btn01"
                @click="getDegree($event)"
                ref="quickDegree"
              >
                快速定级
              </button>
            </div>
            <div class="recommend__footer__tip02">
              <p>
                <img src="//res13.xesimg.com/x5mall/img/tanhao.png" alt="" />注：1.
                回答以上全部问题，点击快速定级，以便给您推荐合适的课程。
              </p>
              <p>2. 已经有想学的课程但不确定是否合适？直接去英语水平测试专区测测吧！</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import types from '../store/types'
export default {
  props: ['data'],
  data() {
    return {
      showDifficultyDegree: false,
      checkedValue: {},
      answerAll: false
    }
  },
  methods: {
    async getDegree(event) {
      const questionList = this.data.question_list
      let checkedItem = []
      for (let i in questionList) {
        const questionId = questionList[i].id
        if (this.checkedValue[questionId]) {
          checkedItem.push(this.checkedValue[questionId])
        } else {
          this.answerAll = true
          return this.answerAll
        }
      }
      this.closeSelf()
      await this.$store.dispatch(types.GET_DIFFICULT_DEGREE, {
        route: this.$route,
        answers: checkedItem.join(','),
        recommendId: this.data.id
      })
      this.$store.commit('SET_SHOWDIFFICULTDEGREE', true)
      this.$store.commit('SET_ISALREADYDEGREE', this.$route.params.subject)
      const xesLog = new this.$XESLog({
        key: 'xeslog-kuaisudingji-courseCenter',
        clickid: '1.2.20',
        gradeid: Number(this.data.grade_id),
        subjectid: Number(this.data.subject_id)
      })
      xesLog.push({ eventname: 'click', target: event.target }, this.$route)
    },
    addCheckMark(questionName, answerId) {
      this.checkedValue[questionName] = answerId
    },
    closeSelf() {
      this.$store.commit('SET_SHOWDIFFCULTRECOMMEND', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(recommend) {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  @include e(dialog) {
    width: 750px;
    position: absolute;
    margin: 10px auto;
    left: 0;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
  @include e(content) {
    position: relative;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    background-clip: padding-box;
    outline: 0;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
  @include e(header) {
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
    min-height: 16.42857143px;
    @include m(close) {
      margin-top: -2px;
      padding: 0;
      cursor: pointer;
      background: transparent;
      border: 0;
      -webkit-appearance: none;
      float: right;
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: 0.2;
    }
    @include e(title) {
      font-size: 15px;
      font-weight: 500;
    }
  }
  @include e(body) {
    padding: 0 45px 28px 45px;
    position: relative;
  }
  @include e(question) {
    width: 100%;
    padding-right: 20px;
    box-sizing: content-box;
    height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  @include e(footer) {
    width: 100%;
    text-align: center;
    margin-top: 50px;
    position: relative;
    @include e(tip01) {
      position: absolute;
      left: 0;
      top: -50px;
      font-size: 13px;
      color: #f13232;
      text-align: left;
      margin-top: 17px;
      margin-bottom: 8.5px;
    }
    @include e(tip02) {
      text-align: left;
      margin-bottom: 0;
      line-height: 22px;
      display: inline-block;
    }
    @include e(btn) {
      width: 370px;
      margin: 0 auto;
    }
    @include e(btn01) {
      width: 140px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #f13232;
      border: 1px solid #f13232;
      color: #fff;
      border-radius: 2px;
      font-size: 16px;
      margin-bottom: 26px;
    }
    @include e(btn02) {
      border: 1px solid #f13232;
      background: #fff;
      color: #f13232;
      float: right;
      width: 180px;
      padding: 0;
      display: inline-block;
      text-align: center;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      font-size: 16px;
      margin-bottom: 26px;
    }
  }
}
.recommend__body h6 {
  font-size: 18px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin: 10px 0;
  font-weight: 500 !important;
}
.recommend__question ul {
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
}
.recommend__question ul li {
  text-align: left;
  margin-bottom: 28px;
  list-style: none;
}
.recommend__question ul li h1 {
  margin: 0.67em 0;
  font-size: 16px;
  margin-bottom: 28px;
  margin-top: 0;
  line-height: 24px;
  color: #333;
  position: relative;
  font-weight: 500;
}
.recommend__question ul li div {
  border: 1px solid #e0e0e0;
  font-size: 16px;
  margin-bottom: 10px;
  padding: 7px 7px 7px 45px;
  box-sizing: border-box;
  position: relative;
  border-radius: 4px;
  width: 100%;
}
.recommend__question ul li div input {
  outline: none;
  font-size: 16px;
  position: absolute;
  left: 10px;
  top: 8px;
  width: 25px;
  height: 25px;
  margin: 0;
  border-radius: 50%;
  background: #e0e0e0;
  border: none;
  &:checked {
    background: #f13232 !important ;
    border: none;
  }
  &::after {
    position: absolute;
    content: '';
    width: 6px;
    height: 12px;
    top: 5px;
    left: 10px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
    box-sizing: border-box;
  }
}
.recommend__question ul li div label {
  font-size: 16px;
  width: 100%;
  font-weight: normal;
  color: #333;
  cursor: pointer;
  padding: 0;
  margin: 0;
  line-height: 30px;
  display: inline-block;
  max-width: 100%;
}
.recommend__footer .recommend__footer__tip02 img {
  width: 16px;
  height: 16px;
  position: relative;
  top: -2px;
  margin-right: 5px;
  vertical-align: middle;
}
.recommend__footer__tip02 p:last-child {
  margin-left: 46px;
}
.checked {
  background: #f13232 !important ;
}
</style>



// WEBPACK FOOTER //
// ./src/components/DifficultRecommend.vue